import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const RefField = ({ label, value, editable, onSave, testid }) => {
  const [v, setV] = useState(value || "");
  useEffect(() => { setV(value || ""); }, [value]);
  const commit = async () => { if (v.trim() !== (value || "") && !(await onSave(v.trim()))) setV(value || ""); };
  return (
    <label className="flex flex-col gap-0.5">
      <span className="text-muted-foreground">{label}</span>
      {editable
        ? <Input value={v} onChange={(e) => setV(e.target.value)} onBlur={commit} onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()}
            className="h-7 text-xs px-2 font-mono" data-testid={testid} />
        : <span className="font-mono" data-testid={testid}>{value || "—"}</span>}
    </label>
  );
};

// Divalto client code (managers/admin, any quote with a client) + signed order references.
export const OrderRefs = ({ quote, canDivalto, canRef, onChange, onClientCode }) => {
  const { t } = useI18n();
  const n = quote.quote_number;
  const signed = !!quote.signature;
  const saveCode = async (v) => {
    try {
      const { data } = await api.put(`/clients/${quote.client_id}/divalto`, { divalto_code: v });
      onClientCode(quote.client_id, data.divalto_code);
      toast.success(t("Code client Divalto enregistré"));
      return true;
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); return false; }
  };
  const save = async (patch) => {
    try {
      const { data } = await api.put(`/quotes/${quote.id}/order-refs`, patch);
      onChange(data);
      toast.success(t("Référence enregistrée"));
      return true;
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); return false; }
  };
  return (
    <div className="mt-1.5 flex flex-col gap-1.5 text-xs w-[170px]" data-testid={`order-refs-${n}`}>
      {quote.client_id && <RefField label={t("Code client Divalto :")} value={quote.client_divalto_code} editable={canDivalto} onSave={saveCode} testid={`client-divalto-${n}`} />}
      {signed && <RefField label={t("Numéro cde Divalto :")} value={quote.divalto_order} editable={canDivalto} onSave={(v) => save({ divalto_order: v })} testid={`divalto-order-${n}`} />}
      {signed && <RefField label={t("Réf cde revendeur :")} value={quote.reseller_ref} editable={canRef} onSave={(v) => save({ reseller_ref: v })} testid={`reseller-ref-${n}`} />}
    </div>
  );
};
